
import Header from '../.shared/header/header';
import Footer from '../.shared/footer/footer';
import Steps from './Steps';
import FeaturedIn from './FeaturedIn';
import Support from './Support';
import SuccessStories from './SuccessStories';
import OriginalHero from './OriginalHero';
import LegitScriptBanner from '../.shared/LegitScriptBanner/LegitScriptBanner';

function SafeAdsLanding() {

    return (
        <>
            <Header hideNavigation={true}/>
            <OriginalHero safeSource={true} />
            <FeaturedIn safeSource={true} />
            <Steps />
            <Support />
            <SuccessStories safeSource={true} />
            <LegitScriptBanner />
            <Footer />
        </>
    );
}

export default SafeAdsLanding;
